/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MoneytreeCallbackPayload } from '../model';
// @ts-ignore
import { MoneytreeStatus } from '../model';
/**
 * MoneytreeApi - axios parameter creator
 * @export
 */
export const MoneytreeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle callback from Moneytree OAuth flow. This endpoint processes the callback from Moneytree after user authorization. It validates the state parameter for CSRF protection and processes the authorization code. 
         * @summary Moneytree Callback
         * @param {MoneytreeCallbackPayload} moneytreeCallbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeCallbackPost: async (moneytreeCallbackPayload: MoneytreeCallbackPayload, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moneytreeCallbackPayload' is not null or undefined
            assertParamExists('v1MoneytreeCallbackPost', 'moneytreeCallbackPayload', moneytreeCallbackPayload)
            const localVarPath = `/v1/moneytree/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moneytreeCallbackPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the reconnection URL for Moneytree bank account reconnection.  This endpoint redirects the user to the appropriate Moneytree reconnection URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page for reconnection - For SSO users: Redirects to Moneytree SSO vault page for reconnection  The URL includes necessary parameters for authentication and state management. 
         * @summary Get Moneytree Reconnect URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeReconnectUrlGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/moneytree/reconnect-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the registration URL for Moneytree bank account registration.  This endpoint redirects the user to the appropriate Moneytree registration URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page - For SSO users: Redirects to Moneytree SSO vault page  The URL includes necessary parameters for authentication and state management. 
         * @summary Get Moneytree Register URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeRegisterUrlGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/moneytree/register-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current Moneytree integration status and available actions.  Returns the connection status and available actions based on the current state: - NOT_CONNECTED: User is not connected to Moneytree - NOT_REGISTERED: Connected but no bank accounts registered - NEED_RELINK: Has unlinked bank accounts that need reconnection - FULLY_LINKED: All bank accounts are properly linked  Returned actions are based on the current state and available actions:\\ If each action is null, it means don\'t show the button.\\ If each action enabled is false, it means show the button, but don\'t enable the button. - registerAccount: Register account action, 銀行口座を登録 Button - reconnectAccount: Reconnect account action, 銀行口座を確認・再連携 Button 
         * @summary Get Moneytree Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeStatusGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/moneytree/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MoneytreeApi - functional programming interface
 * @export
 */
export const MoneytreeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MoneytreeApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle callback from Moneytree OAuth flow. This endpoint processes the callback from Moneytree after user authorization. It validates the state parameter for CSRF protection and processes the authorization code. 
         * @summary Moneytree Callback
         * @param {MoneytreeCallbackPayload} moneytreeCallbackPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MoneytreeCallbackPost(moneytreeCallbackPayload: MoneytreeCallbackPayload, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1MoneytreeCallbackPost(moneytreeCallbackPayload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the reconnection URL for Moneytree bank account reconnection.  This endpoint redirects the user to the appropriate Moneytree reconnection URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page for reconnection - For SSO users: Redirects to Moneytree SSO vault page for reconnection  The URL includes necessary parameters for authentication and state management. 
         * @summary Get Moneytree Reconnect URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MoneytreeReconnectUrlGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1MoneytreeReconnectUrlGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the registration URL for Moneytree bank account registration.  This endpoint redirects the user to the appropriate Moneytree registration URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page - For SSO users: Redirects to Moneytree SSO vault page  The URL includes necessary parameters for authentication and state management. 
         * @summary Get Moneytree Register URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MoneytreeRegisterUrlGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1MoneytreeRegisterUrlGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the current Moneytree integration status and available actions.  Returns the connection status and available actions based on the current state: - NOT_CONNECTED: User is not connected to Moneytree - NOT_REGISTERED: Connected but no bank accounts registered - NEED_RELINK: Has unlinked bank accounts that need reconnection - FULLY_LINKED: All bank accounts are properly linked  Returned actions are based on the current state and available actions:\\ If each action is null, it means don\'t show the button.\\ If each action enabled is false, it means show the button, but don\'t enable the button. - registerAccount: Register account action, 銀行口座を登録 Button - reconnectAccount: Reconnect account action, 銀行口座を確認・再連携 Button 
         * @summary Get Moneytree Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MoneytreeStatusGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoneytreeStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1MoneytreeStatusGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MoneytreeApi - factory interface
 * @export
 */
export const MoneytreeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MoneytreeApiFp(configuration)
    return {
        /**
         * Handle callback from Moneytree OAuth flow. This endpoint processes the callback from Moneytree after user authorization. It validates the state parameter for CSRF protection and processes the authorization code. 
         * @summary Moneytree Callback
         * @param {MoneytreeApiV1MoneytreeCallbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeCallbackPost(requestParameters: MoneytreeApiV1MoneytreeCallbackPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1MoneytreeCallbackPost(requestParameters.moneytreeCallbackPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the reconnection URL for Moneytree bank account reconnection.  This endpoint redirects the user to the appropriate Moneytree reconnection URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page for reconnection - For SSO users: Redirects to Moneytree SSO vault page for reconnection  The URL includes necessary parameters for authentication and state management. 
         * @summary Get Moneytree Reconnect URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeReconnectUrlGet(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1MoneytreeReconnectUrlGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the registration URL for Moneytree bank account registration.  This endpoint redirects the user to the appropriate Moneytree registration URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page - For SSO users: Redirects to Moneytree SSO vault page  The URL includes necessary parameters for authentication and state management. 
         * @summary Get Moneytree Register URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeRegisterUrlGet(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.v1MoneytreeRegisterUrlGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current Moneytree integration status and available actions.  Returns the connection status and available actions based on the current state: - NOT_CONNECTED: User is not connected to Moneytree - NOT_REGISTERED: Connected but no bank accounts registered - NEED_RELINK: Has unlinked bank accounts that need reconnection - FULLY_LINKED: All bank accounts are properly linked  Returned actions are based on the current state and available actions:\\ If each action is null, it means don\'t show the button.\\ If each action enabled is false, it means show the button, but don\'t enable the button. - registerAccount: Register account action, 銀行口座を登録 Button - reconnectAccount: Reconnect account action, 銀行口座を確認・再連携 Button 
         * @summary Get Moneytree Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MoneytreeStatusGet(options?: AxiosRequestConfig): AxiosPromise<MoneytreeStatus> {
            return localVarFp.v1MoneytreeStatusGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for v1MoneytreeCallbackPost operation in MoneytreeApi.
 * @export
 * @interface MoneytreeApiV1MoneytreeCallbackPostRequest
 */
export interface MoneytreeApiV1MoneytreeCallbackPostRequest {
    /**
     * 
     * @type {MoneytreeCallbackPayload}
     * @memberof MoneytreeApiV1MoneytreeCallbackPost
     */
    readonly moneytreeCallbackPayload: MoneytreeCallbackPayload
}

/**
 * MoneytreeApi - object-oriented interface
 * @export
 * @class MoneytreeApi
 * @extends {BaseAPI}
 */
export class MoneytreeApi extends BaseAPI {
    /**
     * Handle callback from Moneytree OAuth flow. This endpoint processes the callback from Moneytree after user authorization. It validates the state parameter for CSRF protection and processes the authorization code. 
     * @summary Moneytree Callback
     * @param {MoneytreeApiV1MoneytreeCallbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoneytreeApi
     */
    public v1MoneytreeCallbackPost(requestParameters: MoneytreeApiV1MoneytreeCallbackPostRequest, options?: AxiosRequestConfig) {
        return MoneytreeApiFp(this.configuration).v1MoneytreeCallbackPost(requestParameters.moneytreeCallbackPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the reconnection URL for Moneytree bank account reconnection.  This endpoint redirects the user to the appropriate Moneytree reconnection URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page for reconnection - For SSO users: Redirects to Moneytree SSO vault page for reconnection  The URL includes necessary parameters for authentication and state management. 
     * @summary Get Moneytree Reconnect URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoneytreeApi
     */
    public v1MoneytreeReconnectUrlGet(options?: AxiosRequestConfig) {
        return MoneytreeApiFp(this.configuration).v1MoneytreeReconnectUrlGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the registration URL for Moneytree bank account registration.  This endpoint redirects the user to the appropriate Moneytree registration URL based on their current status: - For OAuth users: Redirects to Moneytree OAuth authorization page - For SSO users: Redirects to Moneytree SSO vault page  The URL includes necessary parameters for authentication and state management. 
     * @summary Get Moneytree Register URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoneytreeApi
     */
    public v1MoneytreeRegisterUrlGet(options?: AxiosRequestConfig) {
        return MoneytreeApiFp(this.configuration).v1MoneytreeRegisterUrlGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current Moneytree integration status and available actions.  Returns the connection status and available actions based on the current state: - NOT_CONNECTED: User is not connected to Moneytree - NOT_REGISTERED: Connected but no bank accounts registered - NEED_RELINK: Has unlinked bank accounts that need reconnection - FULLY_LINKED: All bank accounts are properly linked  Returned actions are based on the current state and available actions:\\ If each action is null, it means don\'t show the button.\\ If each action enabled is false, it means show the button, but don\'t enable the button. - registerAccount: Register account action, 銀行口座を登録 Button - reconnectAccount: Reconnect account action, 銀行口座を確認・再連携 Button 
     * @summary Get Moneytree Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoneytreeApi
     */
    public v1MoneytreeStatusGet(options?: AxiosRequestConfig) {
        return MoneytreeApiFp(this.configuration).v1MoneytreeStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
}
